/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import IamModal from "./IamModal";
import { iamButtonStyles } from "../../styles/buttonStyles";
import DataGridButton from "../../components/DataGridButton";
import { dataGridButtonTypography } from "../../styles/DataGridStyles";
import { Typography, useTheme } from "@mui/material";
import { VpnKey } from "@mui/icons-material";
import { tokens } from "../../theme";
import { useHasPermission } from "../../api/iam";

/**
 *
 * @param {String} path
 * @param {any[]} dependencies
 * @param {object} dataGridButtonSx
 * @returns
 */
const useIamModal = (
  path = window.location.pathname,
  dependencies = [],
  dataGridButtonSx
) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  const buttonSx = dataGridButtonSx ?? iamButtonStyles(colors);
  const [open, setOpen] = useState(false);

  const canListRoles = useHasPermission(
    `${path}/_iam_/roles`,
    "GET",
    "LIST_ALL",
    dependencies
  );
  const canListGroups = useHasPermission(
    `${path}/_iam_/groups`,
    "GET",
    "LIST_ALL",
    dependencies
  );

  return {
    IamModal: (
      <IamModal
        open={open}
        setOpen={setOpen}
        path={path}
        canListGroups={canListGroups}
        canListRoles={canListRoles}
      />
    ),
    IamButton:
      canListGroups || canListRoles ? (
        <DataGridButton sx={buttonSx} onClick={() => setOpen(true)}>
          <VpnKey sx={{ fontSize: 16, color: "#6B7280" }} />
          <Typography sx={dataGridButtonTypography(colors, 500)}>
            IAM
          </Typography>
        </DataGridButton>
      ) : (
        <></>
      ),
    openIamModal: () => setOpen(true),
    canViewIamModal: canListGroups || canListRoles,
  };
};

export default useIamModal;
